<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-tags"></i> Inquiry Tags
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="offset-2 col-sm-8">
        <ng-select
          matTooltip="Select or create tag(s)"
          matTooltipClass="text-center"
          matTooltipPosition="above"
          [items]="tags"
          [addTag]="addNewTag"
          [hideSelected]="true"
          [selectOnTab]="true"
          appendTo="body"
          multiple="true"
          placeholder="Select or create tag(s)"
          formControlName="tags"
        ></ng-select>
      </div>
    </div>
    <div class="row">
      <div class="offset-2 col-sm-8">
        <p>
          This feature allows you to add arbitrary descriptors to this inquiry which can then
          be used when filtering on various reports and calendars.
        </p>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-save"></i> save
  </button>
</div>
